<template>
  <v-dialog v-model="userDetailDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{t('userInformation')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="userDetailDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('name')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{detailUser.name}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('userId')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{detailUser.userName}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('emailAddress')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{detailUser.mailAddress}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('authority')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{ts(userRole)}}</v-col>
            </v-row>
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between" >
              <v-col class="ma-0 pa-0" cols="auto" align-self="center" >
                {{t('status')}} :
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto" style="width:10rem;" align-self="center">
                <v-select class="ma-0 pa-1 status_select" v-model="selectedStatus"
								:items="cameraStatusList" dense hide-details outlined 
								dark item-text="label" item-value="value"
							  ></v-select>
              </v-col>
            </v-row> -->
            <!-- delete 부분 삭제 -->
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between" >
              <v-col class="ma-0 pa-0" cols="auto" align-self="center" >
                {{t('deleteAccount')}}
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto" align-self="center">
                <v-btn class="ma-0 pa-0" id="red_btn"
					   		  width="8rem" height="2rem">{{t('delete')}}</v-btn>
              </v-col>
            </v-row> -->

            <v-row class="ma-0 pa-0 mt-15 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" @click="userDetailDialogVisible = false"
					   		width="8rem" height="2rem">{{t('cancel')}}</v-btn>
             	<!-- <v-btn class="ma-0 pa-0 ml-2" id="blue_btn" :loading="loading" @click="putShareUser"
					   		width="8rem" height="2rem">{{t('set')}}</v-btn> -->
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
    detailUser: Object
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
  data: () => ({
    userDetailDialogVisible: false,
    detailUserData: {},
		cameraStatusList: [
      {label: '利用停止', value: '0'},
      {label: '利用可能', value: '1'},
    ],
    // selectedStatus: '1',
    loading: false,
    userRole: '',
    adminRoleList: ['0', '10', '20', '30', '1', '11', '21', '31'],
    userRoleList: ['2', '12', '22', '32'],
    viewerRoleList: ['3', '13', '23', '33']
  }),
	watch: {
		dialogVisible: function(item) {
			this.userDetailDialogVisible = item;
		},
    detailUser: function(item) {
      this.detailUserData = item;
      // this.selectedStatus = this.detailUserData.status;
      if(this.adminRoleList.includes(item.role) == true) {
				this.userRole = 'admin';
			}
      else if(this.userRoleList.includes(item.role) == true) {
				this.userRole = 'normalUser';
			}
      else if(this.viewerRoleList.includes(item.role) == true) {
				this.userRole = 'viewer';
			}
    },
		userDetailDialogVisible: function(item) {
			this.$emit('visible', item);
		},
	},
  methods: {
    ts(t) {
      return this.$t("lang.settings." + t);
    },
    // async putShareUser() { //status 저장
    //   this.loading = true;
    //   let params = {
    //     u2productCd: '69',
    //     umid: this.detailUser.umid, 
    //     userStatus: this.selectedStatus,
    //   };
    //   await this.networkController.putShareUser(params)
    //   .then(async(res) => {
    //     this.loading = false;
    //     this.userDetailDialogVisible = false;
    //   }).catch(error => {
    //     if(error.response.status == 401) this.showToastMessage(this.tmb('noAuthAvaiable'));
    //     this.loading = false;
    //     this.userDetailDialogVisible = false;
    //   });
    // },
  },
}
</script>

<style lang="scss" scoped>
.user_detail_list {
  height: 3rem;
  align-content: center;
  border-bottom: 1px solid #707070;
}
.status_select {
  font-size: 0.8em;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .v-list-item--active .v-list-item__content {
    color: white;
  }
  .v-list-item__icon.v-list-group__header__prepend-icon {
    color: white;
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>